import { createFileRoute } from '@tanstack/react-router'
import { ProjectsSettingsSection } from '../../../features/projects/settings-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/projects')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'projects'),
  component: ProjectsSettingsSection,
})
